/**
 * Route for `pixel-capi-dual-send-with-dedup-via-event-id`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PixelCapiDualSendWithDedupViaEventIdPage } from "../features/pixel-capi-dual-send-with-dedup-via-event-id/PixelCapiDualSendWithDedupViaEventIdPage";

export const pixelCapiDualSendWithDedupViaEventIdRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/pixel-capi-dual-send-with-dedup-via-event-id",
	component: PixelCapiDualSendWithDedupViaEventIdPage,
});

export default pixelCapiDualSendWithDedupViaEventIdRoute;
